const ALIASES = [
  ["subjective", ["subjective", "caregiver report", "presentation", "parent report"]],
  ["objective", ["objective", "behavior", "data", "trial", "prompt", "measur", "program"]],
  ["assessment", ["assessment", "medical necessity", "clinical", "progress", "interpretation", "analysis"]],
  ["plan", ["plan", "next session", "recommendation", "homework"]],
];

const sectionOf = (label) => {
  const l = label.toLowerCase();
  return ALIASES.find(([, words]) => words.some((w) => l.includes(w)))?.[0] || null;
};

const unquote = (s) => s.trim().replace(/^["“'‘]+|["”'’]+$/g, "").trim();

export function parseCoachFixes(text) {
  const fixes = {};
  let section = null;
  let find = null;
  text.split("\n").forEach((line, i) => {
    const b = line.match(/\[([^\]]+)\]/);
    if (b) { section = sectionOf(b[1]); find = null; }
    const r = line.match(/^\s*(?:-\s*)?Replace:\s*(.+)$/i);
    if (r) find = unquote(r[1]);
    const t = line.match(/Try:\s*(.+)$/i);
    if (t && unquote(t[1])) {
      fixes[i] = { section, find, replacement: unquote(t[1]) };
      find = null;
    }
  });
  return fixes;
}

const norm = (s) => s.replace(/[“”]/g, '"').replace(/[‘’]/g, "'").replace(/\s+/g, " ").trim().toLowerCase();

function locate(haystack, needle) {
  const exact = haystack.indexOf(needle);
  if (exact >= 0) return [exact, needle.length];
  const n = norm(needle).replace(/[.\s]+$/, "");
  if (!n) return null;
  const map = [];
  let flat = "";
  for (let i = 0; i < haystack.length; i++) {
    const c = haystack[i];
    if (/\s/.test(c) && flat.endsWith(" ")) continue;
    map.push(i);
    flat += /\s/.test(c) ? " " : norm(c) || c.toLowerCase();
  }
  const at = flat.indexOf(n);
  if (at < 0) return null;
  const start = map[at];
  const end = map[at + n.length - 1] + 1;
  return [start, end - start];
}

export function applyCoachFix(form, { section, find, replacement }) {
  const keys = ["subjective", "objective", "assessment", "plan"];
  if (find) {
    for (const k of [section, ...keys].filter(Boolean)) {
      const hit = locate(form[k] || "", find);
      if (hit) {
        const [s, len] = hit;
        let after = form[k].slice(s + len);
        if (/[.!?]$/.test(replacement) && after.startsWith(".")) after = after.slice(1);
        return { key: k, value: form[k].slice(0, s) + replacement + after, mode: "replaced" };
      }
    }
  }
  if (!section) return null;
  const cur = (form[section] || "").trim();
  return { key: section, value: cur ? `${cur} ${replacement}` : replacement, mode: "added" };
}
